export default __webpack_public_path__ + "static/media/background_molecule_4.4eb96095.jpg";